module.exports = __webpack_public_path__ + "static/img/1caca.5d6ddeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/1caca.png
// module id = 227
// module chunks = 1